import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BigIntBaseEntity } from './base.entity';
import { EmailRecordEntity } from './email-record.entity';
import { FileEntity } from './file.entity';

@Entity('email_attachment', {}, { auditable: false })
export class EmailAttachmentEntity extends BigIntBaseEntity {
	@Column({ name: 'fk_email_record__id', type: 'bigint', unsigned: true })
	@Index()
	public emailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, (record) => record.attachments)
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	/**
	 * Provider-side attachment id, used to fetch the bytes back from the
	 * mailbox. NULL for emails we sent ourselves: those never came from a
	 * provider mailbox, so their bytes are stored in `_file` and reached
	 * through `fileId` instead.
	 */
	@Column({
		name: 'external_id',
		type: 'varchar',
		length: 512,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_as_cs',
		nullable: true,
	})
	public externalId?: string;

	@Column({ type: 'varchar', length: 255 })
	public name!: string;

	@Column({ name: 'mime_type', type: 'varchar', length: 150 })
	public mimeType!: string;

	@Column({ type: 'int', unsigned: true, nullable: true })
	public size?: number;

	/** Content-ID for inline/embedded images (used in cid: references) */
	@Column({ name: 'content_id', type: 'varchar', length: 255, nullable: true })
	public contentId?: string;

	/** Whether this attachment is inline (embedded in email body) */
	@Column({ name: 'is_inline', type: 'boolean', default: false })
	public isInline!: boolean;

	/**
	 * Stored copy of the attachment for emails we sent ourselves; NULL for
	 * mailbox-synced attachments, which are fetched from the provider by
	 * externalId.
	 */
	@Column({ name: 'fk_file__id', type: 'int', unsigned: true, nullable: true })
	@Index()
	public fileId?: number;

	@ManyToOne(() => FileEntity)
	@JoinColumn({ name: 'fk_file__id' })
	public file?: FileEntity;
}
